import { render, staticRenderFns } from "./ContasVincular.vue?vue&type=template&id=12b7a0a1"
import script from "./ContasVincular.vue?vue&type=script&lang=js"
export * from "./ContasVincular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports